import React, { useEffect, useState, useMemo } from "react";
import jsPDF from "jspdf";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import DataTable from "react-data-table-component";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import { DATA_EXPORT, ERROR_MESSAGE } from "../../../../src/common/Constant";
import { toastError, toastSuccess } from "../../../../src/common/Toast";
import DeleteConfirmationModal from "../../../components/Modal/DeleteConfirmation";
import CleanupConfirmationModal from "../../../../src/components/Modal/CleanupConfirmation";
import { checkUserPermission } from "../../../common/UserPermission";
import * as XLSX from "xlsx";
import { Noimage } from "../../../common/imagePath";
import moment from "moment";
import ChangePasswordModal from "../../../components/Modal/ChangePassword";
import DeleteIcon from "@mui/icons-material/Delete";

//MUI Table
import { MaterialReactTable } from "material-react-table";
import { MenuItem } from "@mui/material";
import { Box, Button } from "@mui/material";
import CommonMatrialReactTableServerSideRender from "../../../components/Datatable/CommonMatrialReactTableServerSideRender";
import { handleSaveColumnOrder } from "../../../common/common";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";

// The below variable are for permission given to the Functionalities
let PERMISSION_ADD = "/manage-employee";
let PERMISSION_EDIT = "/manage-employee/:id";
let PERMISSION_DELETE = "delete-employees";
let PERMISSION_MANAGE_DELETED_EMPLOYEES = "/deleted-employees";
let PERMISSION_EXCEL_EXPORT = "excelexport-employee";
let PERMISSION_CLEANUP_OLD_EMPLOYEES = "cleanup-old-employees";
let PERMISSION_PERMISSION_TEMPLATE = "/manage-permissions";
let ADD_PERMISSION_TEMPLATE = "/new-permission-template";

let PERMISSION_CUSTOM_FIELD_CONFIGURATION =
  "/custom-field-employee-configuration";

const Employees = () => {
  let selectData = [];
  let pathforpdf = "";
  let navigate = useNavigate();
  const token = localStorage.getItem("Token");
  const [perPageSize, setperPageSize] = useState(25);

  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [sortingId, setSortingId] = useState(6);
  const loginuserid = localStorage.getItem("ID");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [sortingDirection, setSortingDirection] = useState("");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [toggleCleared, setToggleCleared] = useState(false);

  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [selectedDataDelete, setSelectedDataDelete] = useState("");
  const [employeeid, setEmployeeId] = useState(0);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });
  const [PasswordModalOpen, setPasswordModalOpen] = useState(false);

  const [columnVisibility, setColumnVisibility] = useState({});
  const [columnOrder, setColumnOrder] = useState([]);

  const onBtExport = (filterData, field) => {
    const workbook = XLSX.utils.book_new();

    let Data = [];

    if (field === "AllData") {
      Data = data;
    } else {
      Data = filterData?.map((el) => el?.original);
    }

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(Data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `Exel_File.xlsx`);
  };

  // Get all tag data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder
  ) => {
    setLoading(true);
    // const columnIndex = columns.findIndex(
    //   (column) => column.accessorKey === sorting[0]?.id
    // );
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    console.log(
      JSON.stringify(columnFilters) + " columnFilters | ",
      globalFilter + " globalFilter | ",
      pagination.pageIndex + " pagination.pageIndex | ",
      pagination.pageSize + " pagination.pageSize | ",
      columnIndex,
      sorting[0]?.id,
      sorting[0]?.desc === undefined
        ? "desc"
        : (sorting[0]?.desc === true ? "desc" : "asc") + " sorting | ",
      "api Call payload"
    );

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return {
        columnname: el.id,
        value: el.value,
        id: index + 1,
        // count: el.id==="Supplier"? el.value.length:0, ismultiple: el.id==="Supplier"? 1:0
      };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);
    axios
      .get(
        `${
          config.employeesBaseUrl
        }/employees?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? ""
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&loginId=${loginuserid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res76", res);
        setData(res.data.ResponseData?.list);
        setEmployeeId(res.data.ResponseData?.list[0].Id);
        setRowCount(res.data.ResponseData?.list[0]?.TotalRecord);
        setColumnOrder(res.data.ResponseData?.ColumnOrder.split(","));

        const keysToSetFalse = res.data.ResponseData?.ColumnsHide || "";

        // Create default object with all values set to true
        const obj = columns.reduce((acc, item) => {
          acc[item.accessorKey] = true;
          return acc;
        }, {});

        // Comma-separated string of keys to set to false

        // Convert the string to an array and set the corresponding keys in the object to false
        keysToSetFalse.split(",").forEach((key) => {
          if (obj.hasOwnProperty(key)) {
            obj[key] = false;
          }
        });

        setColumnVisibility(obj);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  console.log("data85", data);

  // const formatDate = (string) => {
  //   var options = { year: "numeric", month: "long", day: "numeric" };
  //   return new Date(string).toLocaleDateString([], options);
  // };
  // const formatDate = (string) => {
  //   return moment(string).format("YYYY-DD-MM");
  // };

  // const toogleSelection = (event) => {
  //   setToggleCleared(!toggleCleared);
  // };

  // const handleDeletePopup = (pID) => {
  //   console.log("pID: ", pID);
  //   const deleteRequestParam = {
  //     employeeids: pID || selectedDataDelete,
  //   };
  //   localStorage.setItem(
  //     "DeleteRequestParam",
  //     JSON.stringify(deleteRequestParam)
  //   );
  // };

  const handleDeletePopup = (id, qubid, rows, field) => {
    console.log(id, "id");
    // console.log(rows.map((el) => el.original), "rows231")
    let data;
    let rowdata = [];
    //let quickbookids ;
    if (field == "multipleRowInactive") {
      data = rows.map((el) => el.original.Id).join(",");
      // quickbookids =rows.map((el) => el.original.QuickBookId).join(",");
      rowdata = rows.map((el) => {
        return {
          quickbookid: el.original.QuickbookId,
          // type: el.original.ReceivingTypeId
          //amount : el.original.TransferAmount,
        };
      });
    } else {
      data = id;
      const obj = {
        quickbookids: qubid,
        //amount:amount, // type: receivingtypeid
      };
      rowdata.push(obj);
    }
    const deleteRequestParam = {
      id: data,
      quickbookarray: rowdata,
      loginuserid: loginuserid,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    // setShowDateFilterModal(true);
    // setShowAction(false);
    setDeleteModalOpen(true);
  };

  // const handleRowSelected = (e) => {
  //   if (e.selectedRows.length > 0) {
  //     // for get detlais form id
  //     setSelectedRows(e.selectedRows.map((x) => x.Id));
  //     selectData[currentPage] = e.selectedRows.map((x) => x.Id);
  //     const selectedEmpolyeeCheckboxIDs =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     const selectedDataDelete =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     setSelectedDataDelete(selectedDataDelete);
  //     setselectedEmployeeCheckbox(selectedEmpolyeeCheckboxIDs);
  //     const datasplitforpath = selectedEmpolyeeCheckboxIDs?.split(",");
  //     pathforpdf = datasplitforpath?.join("~");
  //     setselectedEmployeeCheckpathforpdf(pathforpdf);
  //     console.log("Datasasasa", pathforpdf);

  //     // get emails of selectdids
  //     setSelectedRows(e.selectedRows.map((x) => x.Email));
  //     selectData[currentPage] = e.selectedRows.map((x) => x.Email);
  //     const selectedEmployeeCheckboxEmails =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     setselectedEmployeeCheckEmails(selectedEmployeeCheckboxEmails);
  //     console.log(selectedEmployeeCheckboxEmails);
  //   }
  // };

  // const contextActions = useMemo(() => {
  //   // For handle pdf
  //   const handlepdf = () => {
  //     console.log("selectedEmployeeCheckboxs: ", selectedEmployeeCheckboxs);
  //     axios
  //       .get(
  //         `${config.employeesBaseUrl}/employees/employeedetailforlabel?id=${selectedEmployeeCheckboxs}`,
  //         {
  //           headers: {
  //             "Content-Type": "application/json;charset=UTF-8",
  //             Authorization: token,
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         const doc = new jsPDF();

  //         let position = 0;
  //         for (let i = 0; i < res.data.ResponseData.length; i++) {
  //           console.log(res.data.ResponseData.length);
  //           position = position + 10;
  //           doc.setFontSize(10);

  //           doc.text(
  //             `Firstname: ${res.data.ResponseData[i].Firstname}`,
  //             10,
  //             position
  //           );
  //           position = position + 10;
  //           doc.text(
  //             `Lastname: ${res.data.ResponseData[i].Lastname}`,
  //             10,
  //             position
  //           );
  //           position = position + 10;
  //           doc.text(`Email: ${res.data.ResponseData[i].Email}`, 10, position);
  //           position = position + 10;
  //           doc.text(
  //             `Phonenumber: ${res.data.ResponseData[i].Phonenumber}`,
  //             10,
  //             position
  //           );
  //           position = position + 10;
  //           doc.text(
  //             `Address1: ${res.data.ResponseData[i].Address1}`,
  //             10,
  //             position
  //           );
  //           console.log(res.data.ResponseData);

  //           position = position + 10;

  //           if ((i + 1) % 4 == 0) {
  //             doc.addPage();
  //             position = 0;
  //           } else if (i == res.data.ResponseData.length - 1) {
  //           }
  //         }
  //         //   doc.deletePage(Last);
  //         doc.save(`Employee_mailing_label${Date.now()}.pdf`);
  //         setState({ data: res.data.ResponseData });
  //       });
  //   };

  //   return (
  //     <>
  //       {/* E-Mail */}
  //       <div className="row px-2 ">
  //         <div className="col-12 align-self-center">
  //           {checkUserPermission(PERMISSION_EMAIL_EMPLOYEES) ? (
  //             <a href={"mailto:" + selectedEmployeeCheckEmails}>
  //               <button type="button" className="btn btn-dark btn-sm ">
  //                 <i className="fa fa-envelope fa-sm" /> E-mail
  //               </button>
  //             </a>
  //           ) : (
  //             ""
  //           )}
  //         </div>
  //       </div>

  //       {/* Mailing Labels */}
  //       <div className="row px-2">
  //         <div className="col-12 align-self-center">
  //           {/* <a href={"/mailing_labels/" + selectedCustomerCheckpathforpdf}> */}
  //           {checkUserPermission(PERMISSION_MAILING_LABELS) ? (
  //             <button
  //               type="button"
  //               className="btn btn-dark btn-sm"
  //               title="MailingLabels"
  //               onClick={handlepdf}
  //             >
  //               <i className="fa fa-envelope-square fa-sm" /> Mailing-Labels
  //             </button>
  //           ) : (
  //             ""
  //           )}

  //           {/* </a> */}
  //         </div>
  //       </div>

  //       {/* Delete */}
  //       {checkUserPermission(PERMISSION_DELETE) ? (
  //         <button
  //           type="button"
  //           className="btn btn-danger btn-sm pull-left"
  //           data-bs-toggle="modal"
  //           data-bs-target="#DeleteConfirmationModal"
  //           onClick={() => handleDeletePopup()}
  //         >
  //           <i className="fa fa-trash fa-sm" /> Delete Selected
  //         </button>
  //       ) : (
  //         ""
  //       )}

  //       {/* Clear Selection */}
  //       <div className="row px-2">
  //         <div className="col-12 align-self-center">
  //           {/* <a href={"/mailing_labels/" + selectedCustomerCheckpathforpdf}> */}
  //           <button
  //             type="button"
  //             className="btn btn-dark btn-sm"
  //             title="Clear Selection"
  //             onClick={(event) => toogleSelection(event)}
  //           >
  //             <i className="fa fa-envelope-square fa-sm" /> Clear Selection
  //           </button>
  //           {/* </a> */}
  //         </div>
  //       </div>
  //     </>
  //   );
  // }, [data, selectedRows, toggleCleared]);

  useEffect(() => {
    handleListData(1, perPageSize, searchtext, sortingId, sortingDirection);
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
  ]);

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "Id",
      size: 120,
      Cell: checkUserPermission(PERMISSION_EDIT)
        ? ({ row }) => (
            <Box
              component="span"
              sx={(theme) => ({
                borderRadius: "0.3rem",
                color: "#343f62",
                maxWidth: "18ch",
                fontWeight: "700",
                textDecoration: "underline",
                textUnderlineOffset: "3px",
                p: "0.3rem",
                cursor: "pointer",
              })}
              onClick={() => navigate(`/manage-employee/${row.original.Id}`)}
            >
              {row.original.Id}
            </Box>
          )
        : null,
      filterFn: "contains",
    },
    {
      header: "Name",
      accessorKey: "Name",
    },
    {
      header: "Username",
      accessorKey: "Username",
    },
    {
      header: "E-Mail",
      accessorKey: "Email",
    },
    {
      header: "Phone Number",
      accessorKey: "Phonenumber",
      size: "105",
    },
    {
      header: "QB SyncStatus",
      accessorKey: "SyncStatusName",
      size: "90",

      Cell: ({ row }) =>
        row.original.SyncStatusName == "Completed" ? (
          <Box
            // class="text-warning word-break-data"
            // to={`/manage-suppliers/${row.original.SupplierId}`}
            component="span"
            sx={(theme) => ({
              // backgroundColor: '#E8F7F5',
              borderRadius: "0.3rem",
              color: "var(--success-main-color)",
              maxWidth: "9ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.SyncStatusName}
          </Box>
        ) : row.original.SyncStatusName == "Failed" ? (
          <Box
            component="span"
            sx={(theme) => ({
              //  backgroundColor: '#FEF7E2',
              borderRadius: "0.3rem",
              color: "var(--error-main-color)",
              maxWidth: "9ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.SyncStatusName}
          </Box>
        ) : (
          ""
        ),
      // enableGrouping: false, //do not let this column be grouped
    },
    // {
    //   header: "Inactive",
    //   accessorKey: "Inactive",
    //   size: "20",
    // },
    {
      header: "Created On",
      accessorKey: "CreatedDate",
      size: "180",
      Cell: ({ row }) =>
        moment(row.original.CreatedDate).format("MM/DD/YYYY h:mm A"),
    },
  ]);

  const handleExcelExport = () => {
    console.log("hello");
    setLoading(true);
    axios
      .post(
        `${config.employeesBaseUrl}/employees/excelexport`,
        {
          filtertext: searchtext,
          ordercolumn: sortingId,
          currentorder: sortingDirection,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("res ==> ", res.data.ResponseData);

        const data =
          res.data.ResponseData.length > 0 ? res.data.ResponseData : [];

        // Create a new workbook
        const workbook = XLSX.utils.book_new();

        // Convert the data to a worksheet
        const worksheet = XLSX.utils.json_to_sheet(data);

        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Save the workbook as an Excel file
        XLSX.writeFile(workbook, `employees_details_.xlsx`);
        setLoading(false);
      })
      .catch((err) => {
        toastError(ERROR_MESSAGE);
        setLoading(false);
      });
  };

  const renderRowActionMenuItems = ({ row, closeMenu }) => [
    checkUserPermission("/manage-employee/:id") && (
      <MenuItem
        key="edit"
        onClick={() => navigate(`/manage-employee/${row.original.Id}`)}
      >
        Edit
      </MenuItem>
    ),

    checkUserPermission("/deleted-employees") && (
      <MenuItem
        className="confirm-text"
        title="Delete"
        data-bs-toggle="modal"
        data-bs-target="#DeleteConfirmationModal"
        onClick={() =>
          handleDeletePopup(row.original.Id, row.original.QuickBookId, "", "")
        }
      >
        Delete
      </MenuItem>
    ),

    checkUserPermission("change-password") && (
      <MenuItem
        key="change-password"
        data-bs-toggle="modal"
        data-bs-target="#ChangePasswordModal"
        onClick={() => {
          setPasswordModalOpen(true);
          closeMenu();
          setEmployeeId(row.original.Id);
        }}
      >
        Change password
      </MenuItem>
    ),

    row.original.Attachements ? (
      <a
        key="attachment"
        className="dropdown-item confirm-text"
        href={row.original.Attachements}
        target="_blank"
        rel="noopener noreferrer"
        title="Attachment"
      >
        <MenuItem title="Attachment">Attachments</MenuItem>
      </a>
    ) : null,
  ];

  const renderTopToolbarCustomActions = ({ table }) => (
    <Box
      sx={{
        display: "flex",
        gap: "1rem",
        p: "0.5rem",
        flexWrap: "wrap",
      }}
    >
      {console.log(table, "tables")}

      {/* {(table.getIsSomeRowsSelected() ||
                  table.getIsAllRowsSelected()) &&
                  (checkUserPermission("mark-inactive") ? (
                    <Button
                      // size="small"
                      class="btn btn-sm btn-secondary"
                      disabled={
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()
                      }
                      //only export selected rows
                      onClick={() =>
                        handleDeletePopup(
                          "",
                          "",
                          table.getSelectedRowModel().rows,
                          "multipleRowInactive"
                        )
                      }
                      // startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Mark InActive
                    </Button>
                  ) : (
                    " "
                  ))} */}
      {/* <Button
        size="small"
        onClick={() =>
          setPagination({ ...pagination, pageSize: totalRows })
        }
        variant="contained"
      >
        Get All Data
      </Button> */}
    </Box>
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Employees</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Employees List</li>
              </ul>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              // marginBottom: "20px",
            }}
          >
            <div className="col-md-4">
              {/* <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50"
                onChange={ChangeFilterText}
                value={searchtext}
              /> */}
            </div>
            <div>
              {/* dynamically hide or show columns */}
              <div className="btn-group pull-right ms-2 dropdown">
                {/* <button
                  type="button"
                  className="btn btn-sm btn-outline-primary dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ borderRadius: "5px" }}
                >
                  <i className="fa fa-cog"></i> &nbsp;
                </button> */}
                {/* <div className="dropdown-menu">
                  {columns.map((column) =>
                    // omit Action column
                    column.name.replace(/\s+|-|\/|#/g, "") !== "Action" ? (
                      <div
                        key={column.name.replace(/\s+|-|\/|#/g, "")}
                        className="form-check ms-2 mt-1"
                      >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                          value={column.name.replace(/\s+|-|\/|#/g, "")}
                          checked={
                            !hiddenColumns.includes(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          } // check all checkboxes which are not include in hiddenColumns
                          onChange={() =>
                            handleCheckboxChange(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                        >
                          {column.name}
                        </label>
                      </div>
                    ) : (
                      ""
                    )
                  )}
                </div> */}
              </div>
              {/* <button onClick={() => setHideDirector(!hideDirector)} className="btn btn-outline-primary pull-right ms-2"><i className="fa fa-cog"></i></button> */}
              <div className="btn-group pull-right ms-2 ">
                {/* <button type="button" className="btn btn-outline-dark d-none">
                  More
                </button> */}

                {checkUserPermission("export-button") ? (
                  <div className="mb-3">
                    <button
                      style={{ marginLeft: "12px", width: "max-content" }}
                      // style={{marginLeft : "18px"}}
                      className="btn btn-sm btn-outline-dark btn-sm pull-right mr-3"
                      onClick={handleExcelExport}
                      title="Export to excel for quickbook"
                      // style={{"padding":"6px 6px", fontSize:"15px"}}
                    >
                      Export All
                    </button>
                  </div>
                ) : (
                  ""
                )}

                <div>
                  {checkUserPermission("export-button") ? (
                    <button
                      // className="btn btn-added pull-right"
                      className="btn btn-sm btn-outline-dark btn-sm pull-right mr-3"
                      style={{ width: "max-content" }}
                      onClick={() => onBtExport([], "AllData")}
                    >
                      <i
                        className="fa fa-download mr-2"
                        style={{ color: "#111930" }}
                      ></i>
                      Export Visible Column
                      {/* <i class="fa-thin fa-download"></i> */}
                    </button>
                  ) : (
                    ""
                  )}
                </div>
                {checkUserPermission(PERMISSION_ADD) ? (
                  <Link
                    to="/manage-employee"
                    // className="btn btn-added pull-right"
                    className="btn btn-primary btn-sm pull-right mr-3"
                    style={{ width: "max-content", borderRadius: "8px" }}
                  >
                    <i className="fa fa-plus me-2 lg"></i>
                    New Employee
                  </Link>
                ) : (
                  ""
                )}

                {(checkUserPermission(PERMISSION_PERMISSION_TEMPLATE) ||
                  // checkUserPermission(PERMISSION_CUSTOM_FIELD_CONFIGURATION) ||
                  checkUserPermission(PERMISSION_EXCEL_EXPORT) ||
                  checkUserPermission(PERMISSION_CLEANUP_OLD_EMPLOYEES)) && (
                  // ||  checkUserPermission(PERMISSION_MANAGE_DELETED_EMPLOYEES)
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-dark dropdown-toggle me-1"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{ borderRadius: "5px" }}
                  >
                    More &nbsp;
                    {/* <span className="sr-only">Toggle Dropdown</span> */}
                  </button>
                )}
                <div className="dropdown-menu">
                  <li>
                    {checkUserPermission(PERMISSION_PERMISSION_TEMPLATE) ? (
                      <Link class="dropdown-item" to="/manage-permissions">
                        Permission Template
                      </Link>
                    ) : (
                      ""
                    )}
                    {checkUserPermission(ADD_PERMISSION_TEMPLATE) ? (
                      <Link class="dropdown-item" to="/new-permission-template">
                        Edit/Add Permission Template
                      </Link>
                    ) : (
                      ""
                    )}
                    {/* #27052024HideSection #Comment For Phase-I #HIDE-27-05-2024 #Line 950-2226
                    <li>
                      {checkUserPermission(
                        PERMISSION_CUSTOM_FIELD_CONFIGURATION
                      ) ? (
                        <Link
                          class="dropdown-item"
                          to="/custom-field-employee-configuration"
                        >
                          Employee Custom Fields
                        </Link>
                      ) : (
                        ""
                      )}
                    </li> */}

                    {/* <li>
                      {checkUserPermission(PERMISSION_EXCEL_EXPORT) ? (
                        <Link class="dropdown-item" onClick={handleExcelExport}>
                          Excel Export
                        </Link>
                      ) : (
                        ""
                      )}
                    </li> */}
                    <li>
                      {checkUserPermission(PERMISSION_CLEANUP_OLD_EMPLOYEES) ? (
                        <Link
                          to="#"
                          title="Cleanup old Employees"
                          className="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#CleanupConfirmationModal"
                        >
                          Cleanup old Employees
                        </Link>
                      ) : (
                        ""
                      )}

                      {/* #27052024HideSection #Comment For Phase-I #HIDE-27-05-2024 #Line 990-2226 */}
                      <li>
                        {checkUserPermission(
                          PERMISSION_MANAGE_DELETED_EMPLOYEES
                        ) ? (
                          <Link class="dropdown-item" to="/deleted-employees">
                            Manage Deleted Employee
                          </Link>
                        ) : (
                          ""
                        )}
                      </li>
                      <li>
                        {checkUserPermission(
                          PERMISSION_MANAGE_DELETED_EMPLOYEES
                        ) ? (
                          <Link class="dropdown-item" to="/inactive-employees">
                            Manage InActive Employee
                          </Link>
                        ) : (
                          ""
                        )}
                      </li>
                    </li>
                  </li>
                </div>
                <div
                  className="cursor-pointer mt-1 ml-3"
                  onClick={() =>
                    handleSaveColumnOrder(
                      loginuserid,
                      "employee",
                      columnOrder,
                      token,
                      columnVisibility
                    )
                  }
                  title="Lock Your Sequence"
                  // onMouseEnter={() => setIcon(ColumnOrderIconHover)}
                  // onMouseLeave={() => setIcon(ColumnOrderIcon)}
                >
                  <i class="fa fa-lock columnsLock fs-4"></i>
                </div>
              </div>
            </div>
          </div>

          <div className="row flex-row-reverse mt-2">
            <div className="col-lg-3 col-md-6 col-sm-12 mb-2">
              {/* <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm w-50 pull-right"
                onChange={ChangeFilterText}
                value={searchtext}
              /> */}
            </div>
          </div>

          {/* Customer list */}
          {/* <div className="card"> */}
          {/* <div className="card-body"> */}
          {/* <div className="table-responsive">
                <DataTable
                  title="Employees List"
                  columns={filteredColumns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  dense
                  responsive
                  paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                  persistTableHead
                  sortServer
                  onSort={handleSort}
                  selectableRows
                  contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                />
              </div> */}

          <CommonMatrialReactTableServerSideRender
            MainHeading="Sonar POS"
            ReportHeading="Employee List"
            columns={columns}
            data={data}
            // startdate={startdate}
            // enddate={enddate}
            columnGrouping={[]}
            columnsVisibility={{}}
            enableRowActions={
              checkUserPermission("/manage-employee/:id") ||
              checkUserPermission("/deleted-employees") ||
              checkUserPermission("change-password")
            }
            enableRowSelection={true}
            renderRowActionMenuItems={renderRowActionMenuItems}
            renderTopToolbarCustomActions={renderTopToolbarCustomActions}
            density="comfortable"
            showGlobalFilter={true}
            showColumnFilters={false}
            expanded={true}
            pagination={{ pageIndex: 0, pageSize: 25 }}
            rowCount={rowCount}
            setColumnFilters={setColumnFilters} // for termp comment filteron column
            setGlobalFilter={setGlobalFilter}
            setPagination={setPagination}
            setSorting={setSorting}
            setColumnOrder={setColumnOrder}
            setColumnVisibility={setColumnVisibility} //setColumnVisibility
            state={{
              columnFilters, // for termp comment filteron column
              // globalFilter,
              isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
              columnOrder,
              columnVisibility,
            }}
          />

          {/* <MaterialReactTable
            columns={columns}
            data={data}
            enableColumnResizing
            enableRowActions={
              checkUserPermission("/manage-employee/:id") ||
              checkUserPermission("/deleted-employees") ||
              checkUserPermission("change-password")
            }
            positionGlobalFilter="left"
            // enableEditing
            // editDisplayMode="row"
            // onEditingRowSave={handleSaveRow}
            renderRowActionMenuItems={({ row, closeMenu }) => [
              checkUserPermission("/manage-employee/:id") && (
                <MenuItem
                  key="edit"
                  onClick={() =>
                    navigate(`/manage-employee/${row.original.Id}`)
                  }
                >
                  Edit
                </MenuItem>
              ),

              checkUserPermission("/deleted-employees") && (
                <MenuItem
                  className="confirm-text"
                  to="#"
                  // key="delete"
                  title="Delete"
                  data-bs-toggle="modal"
                  data-bs-target="#DeleteConfirmationModal"
                  onClick={() =>
                    handleDeletePopup(
                      row.original.Id,
                      row.original.QuickBookId,
                      "",
                      ""
                    )
                  }
                >
                  {/* <DeleteIcon /> */}
          {/* Delete
                </MenuItem>
              ),

              checkUserPermission("change-password") && (
                <MenuItem
                  key="edit"
                  data-bs-toggle="modal"
                  data-bs-target="#ChangePasswordModal"
                  onClick={() => {
                    setPasswordModalOpen(true);
                    closeMenu();
                    setEmployeeId(row.original.Id);
                  }}
                >
                  Change password
                </MenuItem>
              ),

              row.original.Attachements ? (
                <a
                  className="dropdown-item confirm-text"
                  href={row.original.Attachements}
                  target="_blank"
                  title="Attachment"
                >
                  <MenuItem title="Attachment">Attachments</MenuItem>
                </a>
              ) : (
                ""
              ),
            ]}
            enableGrouping
            enableStickyHeader
            enableStickyFooter
            enableRowSelection
            enableColumnOrdering
            initialState={{
              density: "compact",
              showGlobalFilter: true,
              expanded: true,
              //expand all groups by default
              // grouping: [""], //an array of columns to group by by default (can be multiple)
              pagination: { pageIndex: 0, pageSize: 25 },
              // sorting: [{ id: "state", desc: false }], //sort by state by default
            }}
            // muiToolbarAlertBannerChipProps={{ color: "primary" }}
            // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
            muiTableBodyProps={{
              sx: () => ({
                "& tr:nth-of-type(even)": {
                  backgroundColor: "var(--datatable-row-background-color)",
                  //'rgb(237 237 233 / 63%)'
                },
                "& td": {
                  borderRight:
                    "1px solid var(--datatable-row-background-hover-color)",
                  lineHeight: "16px",
                  fontWeight: "400",
                  fontSize: "12px",
                  color: "var(--primary-color-800)",
                  fontFamily: "Inter",
                },

                "& tr": {
                  lineHeight: "16px",
                  fontWeight: "400",
                  fontSize: "12px",
                  color: "var(--primary-color-800)",
                  fontFamily: "Inter",
                },
              }),
            }}
            muiPaginationProps={{
              rowsPerPageOptions: [25, 50, 100, 300, 500],
            }}
            muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
            manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={
              isError
                ? {
                    color: "error",
                    children: "Error loading data",
                  }
                : undefined
            }
            muiTableHeadCellProps={{
              sx: (theme) => ({
                background: "var(--datatable-row-background-color)", //'#e9e9e9',
                borderRight:
                  "1px solid var(--datatable-row-background-hover-color)",
                lineHeight: "16px",
                fontWeight: "500",
                fontSize: "14px",
                color: "var(--primary-color-800)",
                fontFamily: "Inter",
              }),
            }}
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={setGlobalFilter}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={totalRows}
            state={{
              columnFilters,
              // globalFilter,
              isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
            renderTopToolbarCustomActions={({ table }) => (
              <Box
                sx={{
                  display: "flex",
                  gap: "1rem",
                  p: "0.5rem",
                  flexWrap: "wrap",
                }}
              >
                {(table.getIsSomeRowsSelected() ||
                  table.getIsAllRowsSelected()) &&
                  (checkUserPermission("/deleted-employees") ? (
                    <Button
                      // size="small"
                      className="btn btn-sm btn-secondary"
                      style={{ display: "flex" }}
                      disabled={
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()
                      }
                      //only export selected rows
                      onClick={() =>
                        handleDeletePopup(
                          "",
                          "",
                          table.getSelectedRowModel().rows,
                          "multipleRowInactive"
                        )
                      }
                      // startIcon={<FileDownloadIcon />}
                      startIcon={<DeleteIcon />}
                      variant="contained"
                    >
                      Delete Selected
                    </Button>
                  ) : (
                    " "
                  ))}
              </Box>
            )}
          /> */}
          {/* </div> */}
          {/* </div> */}
        </div>
      </div>

      {/* Delete Model  */}
      <DeleteConfirmationModal
        deleteApiUrl={`${config.employeesBaseUrl}/employees/batchdelete`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />

      <ChangePasswordModal
        Module={"Employees"}
        employeeid={employeeid}
        open={PasswordModalOpen}
        onClose={() => setPasswordModalOpen(false)}
      />

      {/* Cleanup old suppliers */}
      <CleanupConfirmationModal
        CleanupConformationApiUrl={`${config.employeesBaseUrl}/employees/deletepermanantely`}
      />
    </>
  );
};

export default Employees;
